
if (!customElements.get("quick-change")) {
    customElements.define("quick-change", class QuickChange extends HTMLElement {
        constructor() {
            super();
            const radioPrefix = 'cart-edit-' + (window.klCartEditorIndex = (window.klCartEditorIndex || 0) + 1);
            this.querySelectorAll('.swatch input[type=radio]').forEach((input, index) => {
                const oldId = input.id;
                const name = input.dataset.optionName || input.name;
                input.dataset.optionName = name;
                input.name = radioPrefix + '-' + name;
                input.id = radioPrefix + '-' + index;
                this.querySelectorAll('label').forEach(label => { if (label.htmlFor === oldId) label.htmlFor = input.id; });
            });
            // 获取产品信息
            this.product = JSON.parse(this.querySelector("product-data").innerHTML);
            this.line = Number(this.querySelector("line-data").innerHTML);
            // 获取li元素的高度 & ul Dom
            this.sliderHeight = this.querySelector(".slider")?.clientHeight || 50;
            this.sliderWrapper = this.querySelector(".product-swiper");
            // 获取切换按钮 & 事件监听
            this.preBtn = this.querySelector(".slide-to-pre");
            this.nextBtn = this.querySelector(".slide-to-next");
            this.preBtn?.addEventListener("click", (e) => {
                e.preventDefault();
                this.sliderWrapper.scrollBy({
                    left: 0,
                    top: -this.sliderHeight,
                    behavior: "smooth"
                })
            })
            this.nextBtn?.addEventListener("click", (e) => {
                e.preventDefault();
                this.sliderWrapper.scrollBy({
                    left: 0,
                    top: this.sliderHeight,
                    behavior: "smooth"
                })
            })
            // 购物车item已选变体的信息
            this.selectedValueInCart = String(this.querySelector("selected-data")?.innerHTML).split("||");
            // 性能优化：单次DOM查询 
            this.domCache = {
                sliderWrapper: this.querySelector(".product-swiper"),
                rightAreaLink: this.querySelector(".right-area  a"),
                rightAreaImg: this.querySelector(".right-area  img")
            };
            // 事件委托配置 
            this._initEventDelegation();
            this.quantityEl = this.querySelector(".qty");
            // 给数量加减按钮增减事件
            this.querySelector(".des.button").addEventListener("click", () => {
                if (Number(this.quantityEl.value) > 1) {
                    this.quantityEl.value = Number(this.quantityEl.value) - 1
                }
            })
            this.querySelector(".inc.button").addEventListener("click", () => {
                this.quantityEl.value = Number(this.quantityEl.value) + 1
            })

            // 关闭按钮
            this.querySelector(".close-btn").addEventListener("click", () => {
                document.querySelector('.dialog-wrapper').classList.remove("open");
            })


            this.originalItem = JSON.parse(this.dataset.item || '{}');
            const sizeSelect = this.querySelector('.size-data');
            const measurementHost = this.querySelector('.kl-cart-measurements');
            const sizing = window.KiarelysCustomSizing;
            if (sizeSelect && measurementHost && sizing) {
                const initial = sizing.fromProperties(this.originalItem.properties);
                // Existing custom orders have already accepted these terms on the product page.
                this.measurements = sizing.mount(measurementHost, initial);
                const toggleMeasurements = () => {
                    measurementHost.hidden = !/^custom size$/i.test(sizeSelect.value.trim());
                };
                sizeSelect.addEventListener('change', toggleMeasurements);
                toggleMeasurements();
            }
            this.udpateBtn = this.querySelector('.update-cart-btn');
            this.udpateBtn?.addEventListener('click', () => this.saveItem());

            // 弹出事件
            this.closest("tr")?.querySelector(".update.btn")?.addEventListener("click", () => {
                const popup = document.querySelector('.popup-product-info');
                popup.style.removeProperty('--kl-editor-height');
                popup.innerHTML = this.outerHTML;
                document.querySelector(".dialog-wrapper").classList.add("open");
                if (window.matchMedia('(min-width: 751px)').matches) {
                    const padding = getComputedStyle(popup);
                    const contentHeight = popup.clientHeight - parseFloat(padding.paddingTop) - parseFloat(padding.paddingBottom);
                    popup.style.setProperty('--kl-editor-height', contentHeight + 'px');
                }
            })

            // 选择颜色后更新主图
            this.querySelector(".collection_variants_sort_show_now")?.addEventListener("change", (e) => {
                if (e.target.tagName === "INPUT") {
                    const targetVariantId = Number(e.target.parentElement.getAttribute("data-varid"));
                    const variantImgSrc = this.product.variants.find(item => item.id === targetVariantId)?.featured_image?.src;
                    if (variantImgSrc) {
                        this._updateRightArea(null, variantImgSrc);
                    }
                }
            })

            // 初始化已选择的颜色
            this.selectedValueInCart.forEach(item => {
                Array.from(this.querySelectorAll('.swatch input[type=radio]')).find(input => input.value === item)?.click()
            })
            this.querySelector(".collection_variants_sort_show_now")?.addEventListener("change", (e) => {
                if(e.target.tagName === "INPUT") {
                    this.querySelector(".select_color_value").innerHTML = e.target.value;
                }
            })

        }

        async saveItem() {
            if (this.udpateBtn.disabled) return;
            const error = this.querySelector('.kl-cart-save-error');
            error.hidden = true;
            try {
                const quantity = Number(this.quantityEl.value);
                if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please enter a whole quantity of at least 1.');
                const selected = this.product.options.map((name, index) => {
                    const inputs = Array.from(this.querySelectorAll('.swatch input[type=radio]:checked'));
                    return inputs.find(input => input.dataset.optionName === name)?.value || this.selectedValueInCart[index];
                });
                const variant = this.product.variants.find(candidate => candidate.options.every((value, i) => value === selected[i]));
                if (!variant || !variant.available) throw new Error('This combination is unavailable. Please choose another option.');
                const size = this.querySelector('.size-data')?.value;
                let properties = { ...this.originalItem.properties };
                if (size) {
                    if (/^custom size$/i.test(size.trim())) {
                        if (!this.measurements) throw new Error('Please reload the page to load custom sizing.');
                        if (!this.measurements.showErrors().valid) return;
                        const data = this.measurements.read();
                        properties = window.KiarelysCustomSizing.replaceProperties(properties, data.values, data.unit);
                    } else properties = window.KiarelysCustomSizing.clearProperties(properties, size);
                }
                this.udpateBtn.disabled = true;
                this.udpateBtn.textContent = 'Updating...';
                const root = window.Shopify?.routes?.root || '/';
                const request = async (path, body) => {
                    const response = await fetch(root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
                    const result = await response.json();
                    if (!response.ok) throw new Error(result.description || result.message || 'Unable to update the cart. Please try again.');
                    return result;
                };
                const cart = await request('cart.js');
                const original = cart.items.find(item => item.key === this.originalItem.key);
                if (!original) throw new Error('This cart item has changed. Please refresh the page before editing it.');
                if (Number(variant.id) === Number(original.variant_id)) {
                    await request('cart/change.js', { id: original.key, quantity, properties });
                } else {
                    const item = { id: variant.id, quantity, properties };
                    if (original.selling_plan_allocation) item.selling_plan = original.selling_plan_allocation.selling_plan.id;
                    // Add successfully before removing the original, so an unavailable variant cannot lose the item.
                    await request('cart/add.js', { items: [item] });
                    try { await request('cart/change.js', { id: original.key, quantity: 0 }); }
                    catch (failure) {
                        error.textContent = 'The new selection was added, but the original item could not be removed. Please refresh and review your cart before continuing.';
                        error.hidden = false;
                        this.udpateBtn.textContent = 'Refresh cart';
                        this.udpateBtn.disabled = false;
                        this.saveItem = () => location.reload();
                        return;
                    }
                }
                location.reload();
            } catch (failure) {
                error.textContent = failure.message || 'Unable to update the cart. Please try again.';
                error.hidden = false;
                this.udpateBtn.disabled = false;
                this.udpateBtn.textContent = 'Update Cart';
            }
        }

        connectedCallback() {

        }

        _initEventDelegation() {
            // 单一事件监听器处理所有缩略图点击 
            this.domCache.sliderWrapper?.addEventListener('click', (e) => {
                const thumbLink = e.target.closest('.fancybox-thumb');
                if (!thumbLink) return;

                // 性能优化：RAF处理重绘 
                requestAnimationFrame(() => {
                    this._updateRightArea(thumbLink);
                });
            });
        }
        _updateRightArea(thumbLink, url) {
            // 同步更新所有必要属性 
            if (!url) {
                const targetImg = thumbLink.querySelector('img');
                const newHref = thumbLink.href;
                const newSrc = targetImg.currentSrc || targetImg.src;

                // 原子化属性更新 
                this.domCache.rightAreaLink.href = newHref;
                this.domCache.rightAreaImg.src = newSrc;
                this.domCache.rightAreaImg.dataset.src = targetImg.dataset.src;
                this.domCache.rightAreaImg.dataset.aspectratio = targetImg.dataset.aspectratio;
            } else {
                this.domCache.rightAreaLink.href = url;
                this.domCache.rightAreaImg.src = url;
                this.domCache.rightAreaImg.dataset.src = url;
                this.domCache.rightAreaImg.dataset.aspectratio = url;
            }

        }


    })
}

document.querySelector('.dialog-wrapper')?.addEventListener("click", (e) => {
    if (e.target.classList.contains("dialog-wrapper")) {
        document.querySelector('.dialog-wrapper').classList.remove("open");
    }
})

// 给购物车备注添加事件
document.addEventListener("DOMContentLoaded", () => {
    const cartNote = document.querySelector("#cartSpecialInstructions");
    cartNote?.addEventListener("blur", () => {
        fetch("/cart/update.js", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                note: cartNote.value
            })
        }).then(d => d.json()).then(res => {
            alert("Your note has been updated!")
        }).catch(e => {
            alert("There is an error,please try again!")
        })
    })
})